import { render, staticRenderFns } from "./jcdet.vue?vue&type=template&id=99598fe0&"
import script from "./jcdet.vue?vue&type=script&lang=js&"
export * from "./jcdet.vue?vue&type=script&lang=js&"
import style0 from "./jcdet.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports